import {
  Avatar,
  AvatarFallback,
  AvatarImage,
  BodyText,
  HeaderText,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Separator,
  Skeleton,
} from "@/components/ui";
import { Tooltip } from "@/components/ui/Tooltip";
import { getInitials } from "@/lib/utils";
import { Stethoscope } from "lucide-react";
import { useOnlinePractitioners } from "./network/useOnlinePractitioners";

export const OnlinePractictionerPopover = () => {
  const { data: onlinePractitioners, isPending } = useOnlinePractitioners();
  return (
    <Popover>
      <PopoverTrigger>
        <Tooltip tooltipContentText="Online Practitioners" side="right">
          <div className="relative flex items-center justify-center text-white p-2 rounded-lg m-auto w-fit hover:bg-white/25">
            <div className="w-fit min-w-3 h-3.5 top-[-2px] right-[-4px] absolute bg-white text-xs rounded-[4px] flex items-center justify-center p-0.5 pr-1 pl-1 cursor-pointer">
              <BodyText size="xs" textColor="link" className="cursor-pointer">
                {onlinePractitioners?.providers?.length}
              </BodyText>
            </div>
            <Stethoscope size={16} />
          </div>
        </Tooltip>
      </PopoverTrigger>
      <PopoverContent
        side="right"
        className="w-[300px] border-primary border rounded-md p-3 mt-2 gap-2 flex flex-col"
      >
        <HeaderText size="sm">Online Practitioners</HeaderText>
        <Separator />
        {isPending && <Skeleton className="h-[100px] w-full" />}
        <div className="flex flex-col gap-2">
          {onlinePractitioners?.providers?.map((practitioner) => (
            <div className="flex gap-1 items-center" key={practitioner.userId}>
              <Avatar>
                <AvatarImage src={practitioner.photo} />
                <AvatarFallback delayMs={1000}>
                  <BodyText size="sm">
                    {getInitials(practitioner.displayNameInternal)}
                  </BodyText>
                </AvatarFallback>
              </Avatar>
              <BodyText size="sm">{practitioner.displayNameInternal}</BodyText>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
